import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { PlanStep } from '../../../services/PlanStep';
import { StepComponent } from '../../step.component';
import { PlanCoordinate } from '../../../services/plan-coordinate';
import { StrtPriority } from '../../../../shared/models/plan/StrtPriority';
import { Subscription } from 'rxjs/index';
import { StrategiesDataStoreService } from '../../../../shared/services/strategies-data-store.service';
import { DataUtils } from '../../../../shared/utilities/data-utils';
import { StrtObjective } from '../../../../shared/models/plan/StrtObjective';
import { PriorityService } from '../../../services/priority.service';
import { InitiativeService } from '../../../services/initiative.service';
import { take } from 'rxjs/internal/operators';
import { StrtInitiative } from '../../../../shared/models/plan/StrtInitiative';
import { AppLoadingService } from '../../../../app-loading-panel/app-loading.service';
import { ResourceService } from '../../../services/resource.service';

@Component({
  selector: 'app-develop-annual-plan',
  templateUrl: './develop-annual-plan.component.html',
  styleUrls: ['./develop-annual-plan.component.scss']
})
export class DevelopAnnualPlanComponent extends StepComponent<void> implements OnInit, OnDestroy {
  @Input() strategyId: number;

  private prioritiesSubscription: Subscription;

  priorities: StrtPriority[] = [];
  objectivePriorities: StrtPriority[] = [];
  planHasInitiatives = false;
  preventCalendarBlur = false;

  constructor(private _strtDataStore: StrategiesDataStoreService,
              private _priorityService: PriorityService,
              private _initiativeService: InitiativeService,
              private _loadingService: AppLoadingService,
              _resourceService: ResourceService) {
    super(PlanCoordinate.stepBy(PlanStep.DEVELOP_THE_ANNUAL_PLAN), _resourceService);
  }

  ngOnInit(): void {
    this._loadingService.setLoading();
    if (!this.prioritiesSubscription) {
      this.prioritiesSubscription = this._strtDataStore.priorities$.subscribe((priorities: StrtPriority[]) => {
        this.priorities = priorities;
        this.objectivePriorities = this.priorities.filter(it => it.objectives.some(objective => objective.initiatives.length > 0));
        this.updateHasInitiatives(this.objectivePriorities);
        this._loadingService.clearLoading();
      });
    }
    this._priorityService.fetchPriorities(this.strategyId);
  }

  ngOnDestroy(): void {
    if (this.prioritiesSubscription) {
      this.prioritiesSubscription.unsubscribe();
    }
  }

  updateHasInitiatives(priorities: StrtPriority[]) {
    if (priorities.length === 0) {
      return false;
    }
    const outputs = DataUtils.flatten(priorities.map((priority: StrtPriority) => {
      return priority.objectives.map((objective: StrtObjective) => {
        return objective.initiatives.length > 0;
      });
    }));
    this.planHasInitiatives = outputs.indexOf(true) >= 0;
  }

  get planHasPriorities() {
    return this.priorities.length > 0;
  }


  resetCalendarEventBlocker() {
    this.preventCalendarBlur = true;
  }

  allowCalendarBlurEvent() {
    this.preventCalendarBlur = false;
  }

  onChangeDate(event: any, initiative: StrtInitiative) {
    if (event && event.type && event.type === 'blur' && this.preventCalendarBlur) {
      // Allows us to prevent executing this code in an edge caused by p-calendar
      // The edge case is the onBlur event being fired when a user clicks a date
      // The onBlur gets fired before the select event, which ends up clearing out the date
      return;
    }

    if (this.datesAreValid(initiative.startDate, initiative.endDate)) {
      this._loadingService.setLoading();
      this._initiativeService.updateInitiativeDates(initiative).pipe(take(1)).subscribe((updatedInitiative: StrtInitiative) => {
        this._strtDataStore.updateInitiative(initiative, this.priorities);
      }, (err) => {
        this._loadingService.clearLoading();
        console.error(`Error Changing Dates on Initiative: `, err);
      });
    }
  }

  datesAreValid(startDate: Date, endDate: Date): boolean {
    if (startDate && endDate) {
      if (startDate > endDate) {
        return false;
      }
    }

    return true;
  }

}
